<template>
<div class="sidenavright-menu fullheight">
  <div class="sidenavright-content">
      <div class="pill-header">
        <div class="row no-margin">
          <div class="col no-padding">
            <div class="pill-title">
              New Trip
              <sup class="sectitle">{{$moment().format('DD MMM YY')}}</sup>
            </div>
          </div>
          <div class="col-md-auto no-padding bgclose">
            <div class="close-sidebar">
              <svgicon name="cancelwhite" width="14" height="14"
              :original="true" @click="resetValues(); closeMenu();" />
            </div>
          </div>
        </div>
      </div>
      <div class="pill-body" :class="{ 'form-error': $v.trip.$error }">
        <div class="pill-row ">
          <div class="tab-body">
            <div class="form-group">
              <div class="form-list wp50">
                <label>Reference City</label>
                <div class="cardlist-dropdown">
                  <Select v-model="trip.referenceCity" filterable>
                    <Option
                    v-for="city in referenceCityList"
                    :key="city.id"
                    :label="city.name"
                    :value="city.name">
                    </Option>
                    </Select>
                  </div>
                  <div class="error-msg" v-if="!$v.trip.referenceCity.required">
                    Reference City is required
                  </div>
              </div>
              <div class="form-list wp50">
                <label>Reference ID</label>
                <input type="text" class="form-control" placeholder="Enter ID" v-model.trim="trip.customer_reference">
              </div>
            </div>
            <div class="form-group">
              <div class="form-list wp50">
                <label>Source Location</label>
                <input type="text" class="form-control" placeholder="Enter area" v-model.trim="trip.source">
                <div class="error-msg" v-if="!$v.trip.source.required">
                Source Area is required
                </div>
              </div>
              <div class="form-list wp50">
                <label>Destination Location</label>
                <input type="text" class="form-control" placeholder="Enter area" v-model.trim="trip.destination">
                 <div class="error-msg" v-if="!$v.trip.destination.required">
                Destination Area is required
                </div>
              </div>
            </div>
            <div class="form-group no-margintop">
              <div class="form-list wp50">
                <label>Source Pincode</label>
                <input type="text" class="form-control" maxlength="6" @keypress="onlyNumber" placeholder="Enter pincode" v-model.trim="trip.source_pincode">
                <div class="error-msg" v-if="!$v.trip.source_pincode.required">
                Source pincode is required
                </div>
              </div>
              <div class="form-list wp50">
                <label>Destination Pincode</label>
                <input type="text" class="form-control" maxlength="6" @keypress="onlyNumber"  placeholder="Enter pincode" v-model.trim="trip.destination_pincode">
                <div class="error-msg" v-if="!$v.trip.destination_pincode.required">
                Destination pincode is required
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="form-list wp50">
                <label>Truck Number</label>
                <input type="text" class="form-control" placeholder="Enter number" v-model.trim="trip.truck_number" @input="trip.truck_number = $event.target.value.toUpperCase()">
                <div class="error-msg" v-if="!$v.trip.truck_number.required">
                Truck Number is required
                </div>
              </div>
              <div class="form-list wp50">
                <label>Driver Number (+91) - </label>
                <input type="text" class="form-control" maxlength="10" @keypress="onlyNumber" placeholder="Enter number" v-model.trim="trip.driver_number">
                <div class="error-msg" v-if="!$v.trip.driver_number.required">
                Driver Number is required
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="form-list wp50">
                <label>Ping Frequency</label>
                <div class="cardlist-dropdown">
                  <Select v-model="trip.ping_frequency_minutes">
                    <Option
                    v-for="frequency in frequencyList"
                    :key="frequency.id"
                    :label="frequency.name"
                    :value="frequency.id">
                    </Option>
                    </Select>
                  </div>
              </div>
              <div class="form-list wp50">
                <label>Auto Complete By</label>
                <div class="cardlist-dropdown">
                  <Select v-model="trip.auto_complete_by">
                    <Option
                    v-for="autoComplete in autoCompleteList"
                    :key="autoComplete.id"
                    :label="autoComplete.name"
                    :value="autoComplete.id">
                    </Option>
                    </Select>
                  </div>
              </div>
            </div>
            <div class="form-inline">
              <label class="inline-lable">Telecom Partner JIO</label>
              <div class="inline-right">
                <label>
                  <input type="radio" name="telePartner" value="true" v-model="trip.isJio" class="radio">
                  <span>Yes</span>
                </label>
                <label>
                  <input type="radio" name="telePartner" value="false"  v-model="trip.isJio"  class="radio">
                  <span>No</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formfooter">
        <div class="btnaction" v-if="!trackFormLoading">
          <button type="button" class="btn section_sbtn" @click="resetValues(); closeMenu();">Cancel</button>
          <button type="button" class="btn section_pbtn" @click="validateForm">Start Trip</button>
        </div>
      </div>
  </div>
</div>
</template>
<script type="text/javascript">
import { required, requiredIf } from 'vuelidate/lib/validators';
import { mapState } from "vuex";
import frequencyList from '@/constants/tracking';
import { autoCompleteList } from '@/constants/tracking';

const defaultTripValue = {
  referenceCity: '',
  customer_reference: '',
  source: '',
  destination: '',
  source_pincode: '',
  destination_pincode: '',
  truck_number: '',
  driver_number: '',
  ping_frequency_minutes: 15,
  auto_complete_by: 24,
  isJio: false,
};

export default {
  props: [
   'referenceCityList',
  ],
  data() {
    return {
      trip: defaultTripValue,
      frequencyList,
      defaultTripValue,
      autoCompleteList,
    };
  },
  validations: {
    trip: {
      referenceCity: { 
        required: requiredIf(function (value) {
          return (this.referenceCityList.length > 0) ? true : false;
        })
      },
      source: {
        required,
      },
      destination: {
        required,
      },
      source_pincode: {
        required,
      },
      destination_pincode: {
        required,
      },
      truck_number: {
        required,
      },
      driver_number: {
        required,
      },
    },
  },
  computed: {
    ...mapState("tracking", ["trackFormLoading"]),
  },
  methods: {
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
      $event.preventDefault();
      }
    },
    validateForm() {
      this.$v.trip.$touch();
      if (!this.$v.trip.$error) {
        const data = {
          referenceCity: (this.trip.referenceCity === null) ? '' : this.trip.referenceCity,
          ...this.trip.customer_reference && { customer_reference: this.trip.customer_reference },
          source: this.trip.source,
          destination: this.trip.destination,
          source_pincode: this.trip.source_pincode,
          destination_pincode: this.trip.destination_pincode,
          truck_number: this.trip.truck_number,
          driver_number: this.trip.driver_number,
          ping_frequency_minutes: this.trip.ping_frequency_minutes,
          auto_complete_by: this.trip.auto_complete_by,
          isJio: this.trip.isJio,
        };
        this.$emit('newTripAdd', data);
        this.resetValues();
      }
    },
    closeMenu() {
      this.$emit('close');
    },
    resetValues() {
      this.$v.trip.$reset();
      this.trip = {
        referenceCity: null,
        customer_reference: null,
        source: null,
        destination: null,
        source_pincode: null,
        destination_pincode: null,
        truck_number: null,
        driver_number: null,
        ping_frequency_minutes: 15,
        auto_complete_by: 24,
        isJio: false,
        };
    }
  },
};
</script>

<style lang="scss" scoped>
.sectitle {
  display: block;
  margin-top: 15px;
  font-family: 'OpenSans-Regular';
  font-size: 1.2rem;
  color: #A3A3A3;
}
</style>
